
import { RSAA } from 'redux-api-middleware';
import { CACHEABLE } from 'src/redux/apiCacheMiddleware';
import selectDeliveryType from 'src/redux/cart/general/selectDeliveryType';
import { selectAppConfig } from 'src/utils/appConfig/selectAppConfig';
import { FETCH_CATEGORY_DATA_ERROR, FETCH_CATEGORY_DATA_REQUEST, FETCH_CATEGORY_DATA_SUCCESS, FETCH_LOAD_MORE_CATEGORY_SUCCESS } from '../catalogueTypes';
import { selectSelectedCategory } from '../selectors';

const createGetCategoryDataThunk = (successActionType: string) => (storeId: string, params: string) => async (dispatch, getState) => {
  const state = getState();
  const deliveryType = selectDeliveryType(state);

  const { id: categoryId } = selectSelectedCategory(state);
  const { fetchConfig } = selectAppConfig(state);
  const { xChain, xVersion, apiRoot, language } = fetchConfig;

  await dispatch({
    [CACHEABLE]: {
      cacheKey: `${language}-stores-${storeId}-categories-${categoryId}-products-${params}`,
      successActionType: successActionType,
    },
    [RSAA]: {
      method: ('GET'),
      endpoint: `${apiRoot}/stores/${storeId}/categories/${categoryId}/products/${params}`,
      headers: {
        'Accept-Language': language,
        'x-chain': xChain,
        'x-version': xVersion,
        'X-Delivery-Type': deliveryType,
      },
      credentials: 'include',
      types: [
        FETCH_CATEGORY_DATA_REQUEST,
        successActionType,
        FETCH_CATEGORY_DATA_ERROR,
      ],
    },
  });
};

export const fetchLoadMoreCategoryData = createGetCategoryDataThunk(FETCH_LOAD_MORE_CATEGORY_SUCCESS);
export const fetchCategoryData = createGetCategoryDataThunk(FETCH_CATEGORY_DATA_SUCCESS);

